/** @format */

import React from "react";
import ReactImg from "../assets/images/react.png";

const BlogMain = () => {
	return (
		<div className="row">
			<h4 className="font-weight-bold">BLOG POSTS</h4>
			<div className="col">
				<div className="row blog-card">
					<div className="col-5 col-md-4 px-2">
						<div className="rotate-block">
							<img
								src={ReactImg}
								className="image-fluid rotate"
								alt=""
							/>
						</div>
					</div>
					<div className="col-7 col-md-8 px-2 blog-text px-lg">
						<h4 className="font-weight-bold">
							Building and Deploying a react application from
							scratch (Part 1)
						</h4>
						<h6>
							In this article, I will be introducing us to setting
							up a standard react application and deploying it on
							a cloud platform, heroku... <br />
							<a
								target="__blank"
								href="https://codeleaf.hashnode.dev/building-and-deploying-a-react-application-from-scratch-part-1-ck90mbw5k01f67us12ohg1742"
							>
								{" "}
								continue reading...
							</a>
						</h6>
					</div>
				</div>
				<div className="row blog-card mt">
					<div className="col-5 col-md-4 px-2">
						<div className="rotate-block">
							<img
								src={ReactImg}
								className="image-fluid rotate"
								alt=""
							/>
						</div>
					</div>
					<div className="col-7 col-md-8 px-2 blog-text px-lg">
						<h4 className="font-weight-bold">
							Building and Deploying a react application from
							scratch (Part 2)
						</h4>
						<h6>
							Welcome back to the tutorial. If you missed Part 1,
							check it here. In this article, we will be setting up
							the transpiler, bundler and our react...
							<br />
							<a
								target="__blank"
								href="https://codeleaf.hashnode.dev/building-and-deploying-a-react-application-from-scratch-part-2-ck9dhbjfs04yycxs15gi4sjxt"
							>
								{" "}
								continue reading...
							</a>
						</h6>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BlogMain;
